import React from 'react';
import { useLocation } from "react-router-dom";
import { IconButton, Button, Typography } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { clearProfileState } from '../../Redux/Reducers/ProfileReducer';
import { useDispatch } from 'react-redux';
import { clearCardDataState } from '../../Redux/Reducers/CardReducer';
import { clearPrivateIDState } from '../../Redux/Reducers/KycReducer';

const Lightbox = ({ isLightBoxVisible, setIsLightBoxVisible }) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const handleLogout = async () => {
        localStorage.removeItem('objectId');
        localStorage.removeItem('userDetails');
        localStorage.removeItem('personal_Info');
        localStorage.removeItem('Health_Info');
        localStorage.removeItem('Health_Doc_Info');
        localStorage.removeItem('family_Info');
        localStorage.removeItem('hobbies_Info');
        localStorage.removeItem('languages_Info');
        window.location.href = `${process.env.REACT_APP_CARD_URL}/login`;
        localStorage.removeItem('professional_Info');
        localStorage.removeItem('professional_Skills');
        localStorage.removeItem('education_Info');
        localStorage.removeItem('certificates_Info');
        localStorage.removeItem('experiences_Info');
        localStorage.removeItem('resume_Info');
        localStorage.removeItem('projects_Info');
        localStorage.removeItem('awards_Info');
        localStorage.removeItem('services_Info');
        localStorage.removeItem('universities_Listdata');

        await dispatch(clearProfileState());
        await dispatch(clearCardDataState());
        await dispatch(clearPrivateIDState());

    }
    const onclose = () => {
        setIsLightBoxVisible(false);
    }

    return (
        <>
            {isLightBoxVisible &&
                // <div className="lightbox-overlay">
                //     <div className="lightbox-content">
                //         <div className="active-component-container">
                //             <>
                //                 <div className='d-flex justify-content-between'>
                //                     <h6 className='heading-fav text-left mt-2 mb-0'>Are you sure you want to log out?</h6>
                //                     <button  className="lightbox-close pointer" onClick={onclose}>×</button>
                //                 </div>
                //                 <p className='heading-fav-content text-left m-0'>Logging out will require you to sign in again to access your account.</p>
                //                 <div className='d-flex justify-content-end'>

                //                     <button onClick={handleLogout} className='mt-2 text-right fav-button pointer'>Logout</button>
                //                 </div>
                //             </>
                //         </div>
                //     </div>
                // </div>

                <div className="lightbox-overlay">
                    <div className="lightbox-content p-4">
                        <div className='d-flex align-items-center justify-content-between'>
                            <h5 className='mb-0' style={{ fontSize: "18px", fontWeight: "bold", color: "black" }}>
                                Are you sure you want to log out?
                            </h5>
                            <IconButton onClick={onclose}>
                                <CloseRoundedIcon />
                            </IconButton>
                        </div>
                        <Typography variant="body2" className="text-muted">Logging out will require you to sign in again to access your account.</Typography>

                        <div className='d-flex justify-content-end' style={{ marginTop: "24px" }}>
                            {/* <Button variant='contained' sx={{ color: "#0044C6" }}>CANCEL</Button> */}
                            <Button onClick={() => setIsLightBoxVisible(false)} className="delete-button_configuration me-3" sx={{ color: "#0044C6" }}>
                                CANCEL
                            </Button>
                            <Button variant='contained' sx={{ backgroundColor: "#0044C6" }} onClick={handleLogout}>LOG OUT</Button>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export default Lightbox;
